function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-919 -395) translate(919 395)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.815 12.871H23.69V8.765c0-4.632-3.714-8.483-8.372-8.553-2.27-.024-4.454.854-6.069 2.439-1.615 1.584-2.527 3.744-2.534 6.001v4.219h-2.12c-1.952.006-3.532 1.577-3.537 3.517v16.88c.005 1.94 1.585 3.51 3.536 3.517h21.221c1.951-.006 3.53-1.578 3.536-3.517v-16.88c-.006-1.94-1.585-3.51-3.536-3.517zm-9.798 10.49v5.951c.004.654-.497 1.2-1.147 1.247-.33.016-.651-.105-.89-.335-.239-.228-.375-.546-.375-.878v-5.988c-1.15-.565-1.762-1.852-1.474-3.106.288-1.254 1.4-2.142 2.68-2.142 1.28 0 2.392.888 2.68 2.142.288 1.254-.323 2.541-1.474 3.106v.003zm4.688-10.7H8.917V8.478c0-3.276 2.638-5.93 5.892-5.93 3.253 0 5.892 2.654 5.892 5.93l.005 4.185h-.001z",
  opacity: 0.34,
  transform: "translate(26.836 22.364)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.125 12.871H23V8.765C23 4.133 19.286.282 14.628.212c-2.27-.024-4.454.854-6.069 2.439-1.615 1.584-2.527 3.744-2.534 6.001v4.219H3.904c-1.952.006-3.532 1.577-3.537 3.517v16.88c.006 1.94 1.586 3.51 3.537 3.517h21.22c1.951-.006 3.53-1.578 3.536-3.517v-16.88c-.005-1.94-1.585-3.51-3.535-3.517zm-9.798 10.49v5.951c.004.654-.497 1.2-1.146 1.247-.33.016-.652-.105-.892-.335-.239-.228-.374-.546-.374-.878v-5.988c-1.15-.565-1.762-1.852-1.474-3.106.288-1.254 1.4-2.142 2.68-2.142 1.28 0 2.392.888 2.68 2.142.288 1.254-.324 2.541-1.474 3.106v.003zm4.688-10.7H8.227V8.478c0-3.276 2.637-5.93 5.892-5.93 3.253 0 5.892 2.654 5.892 5.93l.005 4.185z",
  transform: "translate(26.836 22.364)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 41,
  r: 41,
  className: "primary-stroke",
  strokeWidth: 3.485
}));

function SvgIcLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic-lock.d63da4ac.svg";
export { ForwardRef as ReactComponent };